import { render, staticRenderFns } from "./pie1.vue?vue&type=template&id=1273c1c7&"
import script from "./pie1.vue?vue&type=script&lang=js&"
export * from "./pie1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports